import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import api from "@/lib/api";
import Waveform from "@/components/Waveform";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Sign in with your new password.");
      navigate("/login");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-6 pt-24 pb-16" data-testid="reset-password-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md">
        <p className="eyebrow mb-3">Almost there</p>
        <h1 className="font-anton uppercase text-5xl sm:text-6xl leading-none mb-8">New Password</h1>
        <Waveform color="rgb(var(--graphite))" className="mb-10" />
        {!token ? (
          <div data-testid="reset-no-token">
            <p className="text-chalk/80 leading-relaxed">This reset link is missing or malformed.</p>
            <Link to="/forgot-password" className="btn-pulse inline-flex mt-10" data-testid="request-new-link">Request a New Link</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-6" data-testid="reset-form">
            <div>
              <label className="eyebrow block mb-2">New password</label>
              <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input"
                className="w-full bg-transparent border-b border-border py-3 font-mono text-sm focus:border-pulse outline-none" />
            </div>
            <div>
              <label className="eyebrow block mb-2">Confirm password</label>
              <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input"
                className="w-full bg-transparent border-b border-border py-3 font-mono text-sm focus:border-pulse outline-none" />
            </div>
            {error && <p className="text-destructive font-mono text-xs" data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="reset-submit" className="btn-pulse w-full disabled:opacity-60">
              {loading ? "Updating…" : "Update Password"}
            </button>
          </form>
        )}
      </motion.div>
    </div>
  );
}
